module.exports = __webpack_public_path__ + "assets/notebook.74589411.svg";